<template>
  <div class="sprite-flags" :class="{ active: selectedLen, moveing: isMousemove}" :style="spritesFlagsStyle" @mouseover="overShow" @mouseout="outHide">
    <div class="flags-content" v-if="sprites.length > 1">
      <div v-if="selectedLen === 0">
        <div class="contents-all-zero">
          <span>{{sprites.length}}</span>
        </div>
        <div class="content-line"></div>
        <div class="content-line"></div>
        <div class="content-line"></div>
        <div class="content-line"></div>
        <div class="content-mask" :data-id="dataId"></div>
      </div>
      <div v-if="selectedLen === 1">
        <span class="contents-all-one active" ref="contentsAll">
        </span>
        <div class="content-line"></div>
        <div class="content-line"></div>
        <div class="content-line"></div>
        <div class="content-line"></div>
        <div class="content-mask" :data-id="dataId"></div>
      </div>
      <div v-if="selectedLen > 1">
        <div class="contents-all-num active">
          <span>{{selectedLen}}</span>
        </div>
        <div class="content-mask" :data-id="dataId"></div>
      </div>
    </div>
    <div :class="{'flag-content': true, active: selectedLen===1}" v-else-if="sprites.length == 1" :data-id="dataId">
      <div class="content-all" ref="contentAll"></div>
      <div class="content-mask" :data-id="dataId"></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import handleCrop from '@/components/mixins/handleCrop';

export default {
  mixins: [handleCrop],
  data() {
    return {
      sprites: [],                   // flag中所有的元素
      enterTime: 0,                  // 此flag的入场时间
      exitTime: 0,                   // 此flag的出场时间
      spritesPitch: [],              // flag中选中的元素
      spritesNoPitch: [],            // flag中没有选中的元素
      selectedLen: 0,                // flag中选中的元素的长度
      transform: 0,                  // flag定位信息
      width: 30,
      enterTimeDown: 0,              // 为拖动改变定位存在
      dataId: 'flag',               // flag的dataId 提供拖动的唯一定位
      gridTransform: this.timelineWidth / this.totalTime / 2, // 每一格的距离
      isSelected: false,             // 是否有被选择的元素，用于取消重复选中
      entranceAnim: {},              // 入场时间对象
      isMousemove: false,             // 是否处于移动中
      isShowFlags: false,
      changeData: [], // 撤销数据
      reData: []
    };
  },
  computed: {
    ...mapGetters(["SelectSprites_Msg", "SelectScenes_Msg", "TOOL"]),
    spritesFlagsStyle() {
      const style = {};
      style.width = this.width + 'px';
      style.transform = 'translate(' + ((this.transform < 0 ? 0 :this.transform) + 15 - this.width/2) + 'px, 0px)';
      return style;
    }
  },
  props: ["spriteObject", "spritesContent", "nowTime", "totalTime", "timelineWidth"],
  watch: {
    spriteObject(val, oldval) {
      // 传入对象改变，flag改变
      this.initData();
      this.getSelectedSprites();
      this.$nextTick(() => {
        this.initDom();
      });
    },
    SelectSprites_Msg(val, oldval) {
      // 选中的元素改变的时候，flag改变
      this.initData();
      this.getSelectedSprites();
      this.$nextTick(() => {
        this.initDom();
      });
    },
    enterTime(val, oldval) {
      // 拖动flag的时候，保证梯形和三角拖块的位置
      if(!this.isMousemove) return;
      let entranceAnim = {};
      let exitAnim = {};
      let effect = null;
      let pathAnim = null;
      let drawingDuration = 0;

      entranceAnim.start = (this.enterTime - 500) < 0 ? 0 : (this.enterTime - 500)
      entranceAnim.end = this.enterTime;

      for(let i = 0, len = this.sprites.length; i < len; i++) {
        effect = this.sprites[i].effect;
        if(effect.code === 'None') {
          entranceAnim.start = entranceAnim.end;
        }else if(effect.code === 'Hand') {
          let dur = effect.exitAnim.start - effect.entranceAnim.end;
          dur < 500  && (dur = 500);
          if(effect.drawingDuration > dur) {
            drawingDuration = dur
          } else {
            drawingDuration = effect.drawingDuration
          }
        }

        if(effect.pathAnim.end) {
          // 如果是路径动画的话
          pathAnim = {};
          pathAnim.start = val;
          pathAnim.end = (val - oldval) + effect.pathAnim.end;
          if(pathAnim.end > effect.exitAnim.start) {
            pathAnim.end = effect.exitAnim.start;
          }
          if(pathAnim.end <= effect.entranceAnim.end) {
            pathAnim.end = val + 500;
          }
        }

        this.sprites[i].updateEffect({
          drawingDuration: drawingDuration,
          entranceAnim:entranceAnim,
          pathAnim: pathAnim,
          exitAnim: {
            end: effect.pathAnim.type === 'None' ? this.exitTime: this.exitTime + 500,
            start: this.exitTime
          }
        })

        // effect.init()
      }
      this.$bus.emit('spritesFlagTime', {enterTime: this.enterTime})
    },
    totalTime(val, oldval) {
      //总时间改变，位置改变
      this.transform = this.spriteObject.enterTime/this.totalTime*this.timelineWidth/1000;
      this.gridTransform = this.timelineWidth / this.totalTime / 2;
    },
    timelineWidth(val, oldval) {
      //总长度改变，位置改变
      this.transform = this.spriteObject.enterTime/this.totalTime*this.timelineWidth/1000;
      this.gridTransform = this.timelineWidth / this.totalTime / 2;
    },
    'sprites.length': function(val, oldval) {
      // 拖动分开元素时dom没有显示的BUG
      this.$nextTick(() => {
        this.initDom();
      });
    }
  },
  mounted() {
    this.initData();
    this.getSelectedSprites();
    this.$nextTick(() => {
      this.initDom()
    });
    this.$bus.on('dragsFlags', this.dragsFlags)
    this.$bus.on('flag_resize_width', this.flagResizeWidth)
  },
  methods: {
    dragsFlags(data) {
      // flag的拖拽事件，绑定在父组件的容器中
      if(this.dataId !== data.dataId) return;
      switch (data.type){
        case 'down':
          this.spritesFlagsDown();
          break;
        case 'move':
          this.spritesFlagsMove(data.dx);
          break;
        case 'up':
          this.spritesFlagsUp();
          break;
      }
    },
    flagResizeWidth(data) {
      if(!data.enterTime) {
        this.width = 30;
        return;
      }
      if(this.enterTime === data.enterTime[0] || this.enterTime === data.enterTime[1]) {
        this.width = 15;
      }
    },
    initData() {
      // 初始化数据
      this.sprites = this.spriteObject.sprites;
      this.enterTime = this.spriteObject.enterTime;
      this.dataId = 'flag';
      for(let i = 0; i < this.sprites.length; i++) {
        this.dataId += ('-' + this.sprites[i].id);
      }
      this.transform = this.enterTime/1000/this.totalTime*this.timelineWidth;
      this.getSelectedSprites();
    },
    initDom() {
      // 获取缩略图绑定到dom上
      let dom = {};
      let _sprite;
      if (this.sprites.length === 1 && this.$refs.contentAll) {
        if(this.$refs.contentAll.childNodes.length) {
          this.$refs.contentAll.removeChild(this.$refs.contentAll.childNodes[0])
        }
        _sprite = this.sprites[0];
        dom = this.sprites[0].getThumbnail().children()
          .css({
            // width: 'auto',
            // height: 'auto',
            maxWidth: '100%',
            maxHeight: '100%',
          })[0];
        // 引擎dom没有加载成功的时候缩略图有问题 todo
        dom && this.$refs.contentAll.appendChild(dom);
      } else if(this.sprites.length !== 1 && this.$refs.contentsAll){
        if(this.$refs.contentsAll.childNodes.length) {
          this.$refs.contentsAll.removeChild(this.$refs.contentsAll.childNodes[0])
        }
        if (this.selectedLen === 1) {
          // 为了压缩不变形添加的样式
          _sprite = this.spritesPitch[0];
          dom = this.spritesPitch[0].getThumbnail().children()
            .css({
              // width: 'auto',
              // height: 'auto',
              maxWidth: '100%',
              maxHeight: '100%'
            })[0]
          this.$refs.contentsAll.appendChild(dom);
        }
      }


      $(this.$refs.contentAll).find('.crop-inner-ref').remove();
      $(this.$refs.contentAll).children().each((i, el) => {
        if (i > 0) {
          $(el).remove();
        }
      });
      this.resizeWrapper(this.$refs.contentAll, _sprite);
      this.handleCrop(this.$refs.contentAll, _sprite);
    },
    getSelectedSprites() {
      //将对象中的sprites 分成两份，为选中和没选中
      this.spritesPitch = [];
      this.exitTime = 0;
      this.spritesNoPitch = [].concat(this.sprites);
      for (let i = 0; i < this.sprites.length; i++) {
        for (let j = 0; j < this.SelectSprites_Msg.length; j++) {
          if(this.sprites[i].id === this.SelectSprites_Msg[j].id) {
            this.spritesPitch.push(this.sprites[i]);
            if(this.sprites[i].effect.exitAnim.start > this.exitTime) {
              // 获取出场的位置，给拖动设置边界
              this.exitTime = this.sprites[i].effect.exitAnim.start;
            }
            this.spritesNoPitch[i] = null;
            break;
          }
        }
      }
      this.spritesNoPitch = this.spritesNoPitch.filter((item) => {
        return item !== null
      })
      this.selectedLen = this.spritesPitch.length;
    },
    getTimeFromTransform() {
      // 根据定位求时间的方法
      return Math.round(this.totalTime * this.transform / this.timelineWidth * 2) / 2 * 1000;
    },
    spritesFlagsDown() {
      if(!this.SelectSprites_Msg.length || !this.spritesPitch.length || (this.spritesPitch.length < this.SelectSprites_Msg.length)) {
        if(this.nowTime*1000 < this.sprites[0].effect.entranceAnim.end) {
          this.$emit("update:nowTime", this.sprites[0].effect.entranceAnim.end / 1000)
        } else if(this.nowTime*1000 > this.sprites[0].effect.exitAnim.start) {
          this.$emit("update:nowTime", this.sprites[0].effect.exitAnim.start / 1000)
        }
        if(this.sprites.length === 1) {
          this.TOOL.selectSprite(this.sprites);
        } else {
          let sprites = [];
          // 路径动画和锁定元素不予许多选
          this.sprites.forEach((item, index) => {
            if(item.effect.pathAnim && item.effect.pathAnim.end || item.locked) return;
            sprites.push(item)
          })
          this.TOOL.selectSprite(sprites);
        }
      }
      this.reData = [];
      if(!this.SelectSprites_Msg) return;
      this.SelectSprites_Msg.forEach(s => {
        let info = {
          id: s.id,
          data: {
            entranceAnim:{
              start: s.effect.entranceAnim.start,
              end: s.effect.entranceAnim.end,
            },
            exitAnim: {
              start: s.effect.exitAnim.start,
              end: s.effect.exitAnim.end
            },
            pathAnim: s.effect.pathAnim.target ? {
              start: s.effect.pathAnim.start,
              end: s.effect.pathAnim.end
            } : null
          }
        }
        if(s.effect.code === 'Hand') {
          info.data.drawingDuration = s.effect.drawingDuration
        }
        this.reData.push(info)
      })
      this.enterTimeDown = this.enterTime;
    },
    spritesFlagsMove(dx) {
      let changeTime = 0,
        dx1 = 0;
      // 变化不大时返回
      if(Math.abs(dx - dx1) < 10) return;
      if(!this.isMousemove) {
        this.$bus.emit('timelineFlag_close',{
          exitTime: 'now',
          dataId: this.dataId,
        });
      }
      this.isMousemove = true;
      dx1 = dx;
      if(this.spritesPitch.length && this.spritesNoPitch.length) {
        for(let i = 0; i < this.spritesContent.length; i++ ) {
          if(this.spritesContent[i].enterTime == this.spriteObject.enterTime) {
            this.sprites = [].concat(this.spritesPitch);
            this.spritesContent.push({
              enterTime: this.spriteObject.enterTime,
              sprites: [].concat(this.spritesNoPitch),
              len: this.spritesNoPitch.length
            })
            this.spritesNoPitch = [];
            break;
          }
        }
      }
      if(!this.spritesPitch.length) return;
      changeTime = Math.round(dx/this.gridTransform)/2*1000;
      if(this.enterTimeDown + changeTime < 0 || this.enterTimeDown + changeTime > this.exitTime) return;
      this.enterTime = this.enterTimeDown + changeTime;
      this.transform = this.enterTime/1000/this.totalTime*this.timelineWidth;
    },
    spritesFlagsUp() {
      if(this.isMousemove && this.spritesPitch.length) {
        this.changeData = [];
        this.sprites.forEach(s => {
          let info = {
            id: s.id,
            data: {
              entranceAnim:{
                start: s.effect.entranceAnim.start,
                end: s.effect.entranceAnim.end,
              },
              exitAnim: {
                start: s.effect.exitAnim.start,
                end: s.effect.exitAnim.end
              },
              pathAnim: s.effect.pathAnim.target ? {
                start: s.effect.pathAnim.start,
                end: s.effect.pathAnim.end
              } : null
            }
          }
          if(s.effect.code === 'Hand') {
            info.data.drawingDuration = s.effect.drawingDuration
          }
          this.changeData.push(info);
        })

        eve("undo_redo", null, {type: 'timeline_drag', data: {
          scenesId: this.SelectScenes_Msg.id,
          reData: this.reData,
          changeData: this.changeData
        }})
      }
      this.isMousemove = false;
      this.$bus.emit('spritesFlagChange', true)
    },
    overShow(e) {
      if(this.isMousemove) return;
      this.$bus.emit('FeaturesPop_vue',{
        type : 1,  // 弹窗的类型 1级弹窗 < 2级弹窗
        name : 'timelineFlag',
        exitTime: 'none',
        dataId: this.dataId,
        sprites : this.sprites,
        posx : e.pageY-e.offsetY - 60,  // 弹窗的定位
        posy : e.pageX-e.offsetX + this.width / 2,
      });
      this.$bus.emit('timelineFlag_close',{
        exitTime: 'none',
        dataId: this.dataId,
      });
    },
    outHide(e) {
      this.$bus.emit('timelineFlag_close',{
        dataId: this.dataId,
        exitTime: this.sprites.length > 1 ? 'later' : 'now',
      });
    }
  },
  beforeDestroy () {
    // 销毁组件的时候取消事件
    this.$bus.off('dragsFlags', this.dragsFlags)
    this.$bus.off('flag_resize_width', this.flagResizeWidth)
  }
};
</script>

<style lang="scss" scoped>
.sprite-flags {
  position: absolute;
  width: 29px;
  height: 30px;
  left: -14px;
  text-align: center;
  margin: 8px 0px;
  border-radius: 4px;

  &.moveing {
    z-index: 100;
  }
  &::before {
      position: absolute;
      width: 0px;
      height: 0px;
      left: 50%;
      top: -4px;
      padding-left: 1px;
      z-index: -1;
      content: " ";
      margin-left: -8px !important;
      border-color: transparent transparent #d4d6e6;
      border-style: solid;
      border-width: 0px 7px 7px !important;
    }

  &.active::before,&:hover::before {
    border-bottom-color: #474261;
  }

  &:hover .flags-content .contents-all-zero,&:hover .flag-content{
    background-color: #474261;
  }

  * {
    box-sizing: border-box;
  }

  .flags-content {
    height: 100%;

    > div {
      display: flex;
      height: 100%;
      flex-direction: column;
    }

    .contents-all-zero,.contents-all-one,.contents-all-num {
      width: 100%;
      height: 100%;
      border-radius: 4px;
      color: #fff;
      background-color: #d4d6e6;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      justify-content: center;
      -webkit-box-flex: 1;
      -ms-flex: 1;
      flex: 1;
      position: relative;
      padding-top: 1px;
      border: solid 2px transparent;
      white-space: nowrap;
      justify-content: center;
      overflow: hidden;

      span {
        border-radius: 50%;
        font-size: 11px;
        font-weight: bold;
        position: absolute;
        width: 100%;
        height: 100%;
        left: 50%;
        top: 50%;
        -webkit-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        -webkit-box-flex: 1;
        -ms-flex: 1;
        flex: 1;
        padding-top: 2px;
      }

      &:hover {
        background-color: #474261;
      }
    }

    .contents-all-one.active,.contents-all-num.active {
      background-color: #474261;
    }

    .content-line {
      width: 100%;
      height: 2px;
      background: #f8f8f8;

      &:nth-child(odd) {
        background: #d4d6e6;
      }
    }
  }

  &.active .content-line:nth-child(odd),&:hover .content-line:nth-child(odd) {
    background: #474261;
  }

  .flag-content {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    border-radius: 4px;
    border: solid 2px transparent;
    background-color: #d4d6e6;
    color: #404e60;

    .content-all {
      position: relative;
      display: flex;
      overflow: hidden;
      width: 100%;
      height: 100%;
      font-size: 11px;
      color: #fff;
      align-items: center;
      white-space: nowrap;
      justify-content: center;
    }

    .content-mask {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
    }
  }

  .content-mask {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }

  .flag-content.active,.flag-content:hover {
    background-color: #474261;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/tool/timeline/spritesFlag.vue